import * as angular from "angular";
import { metadataTab } from "../metadata-tab";
import template from "./view-export-metadata-tab.html";
import type { ModalTabItem } from "../../../../components/modals/tabbed-modal/tabbed-modal-types";

export interface ViewExportMetadataTabController {
	exportLog?: unknown;
}

// eslint-disable-next-line no-redeclare
export class ViewExportMetadataTabController {
	public readonly tab: ModalTabItem = {
		name: "Metadata",
		code: "METADATA"
	};
}

export default angular
	.module("vesl.components.exports.view-export.tabs.metadata", [metadataTab])
	.component("viewExportMetadataTab", {
		controller: ViewExportMetadataTabController,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
